export const issueStatuses = {
  "On Hold": "45d34502-0cab-528d-9264-0a6020f11aaf",
  Acknowledged: "24c5e9ce-5ab1-5b2a-bdcf-9b72375ddbd6",
  Cancelled: "4645b643-9daa-547e-90ad-5b277e667afd",
  Closed: "dc7a63d2-6f9c-5604-ab6b-5e35656d017f",
  New: "2cb21769-d5e7-5c7b-92a9-66c7cec83c4a",
  "Waiting for Information": "f648d9ad-eb41-5743-b42f-69bdcc806f50",
  "In Progress": "13ef0cf5-fccb-5293-b7a6-7b1bdbe40da7",
  Resolved: "5ab495d4-c024-5919-8a46-7bb6a350d901",
  "Pending Review": "7e940e8c-3b72-586e-bd8b-82a8fbe9f497",
  Rejected: "3ef6203f-08a9-5d5b-abb7-a9f6140c0c88",
  Blocked: "d40a6954-576c-51e0-8e14-af0ad16e0bd0",
  Duplicate: "44fbba9f-ec52-583f-8db1-ca989df0a7ae",
  Deferred: "34904305-cd1c-58f8-a58e-cd43734695a7",
  Reopened: "d90ddbba-5776-5cee-bcd2-cda47bd798bf",
  Open: "c5aecfb8-5509-581c-a020-ee346f9775e2",
  NewTG8: "f29219b3-0298-512b-bf64-4dbcc7bfb99f",
  OpenTG8: "6c00e34b-d503-56c3-8992-5783701ebb43",
  Reassignment: "ab932a80-ee8e-5ab7-b70a-9ad957fac15f",
  NewExtension: "451ff4cf-418a-50d9-96c0-ddaf6e920fb7",
  NewReplacement: "0b2e5b56-dc16-5210-a744-5396f2b6e892",
  VoidByPO: "1bb5e2c9-9b9a-59a4-8290-2d62fe246a7e",
  VoidByCB: "2644f649-0882-55fc-a26a-f0a250d71c1e",
};

export const issueTypes = {
  "Error Correction": "b01df1c0-0ea3-5313-bd0c-54931887c428",
  "Certificate Validation": "9524be5a-6656-548a-a3c1-754b20df564a",
  "Error Report": "4e7118b6-4883-567a-b4ad-ab245717ff08",
};

export const certificateValidityStatuses = {
  Expired: "63a507c8-7124-5eec-8510-02b74a3a8dca",
  "Withdrawn (replaced by)": "38fa47c8-12a4-5e6f-b9d1-387d3c8222b8",
  "Withdrawn (not replaced)": "64e89d04-9533-57f4-8f2d-41f340a29d8b",
  Valid: "c47a0b7c-701b-5544-92b0-6bcb48aac633",
  Void: "258a9d1a-5070-562a-a14f-2973c2c70d84",
  "Valid (extended by)": "02ab294a-cfe3-57d0-8831-2d600c44397c",
};

export const isIssueStatus = (status: string) => {
  return Object.values(issueStatuses).includes(status);
};

export const issueStatusFromId = (type: string) => {
  return Object.entries(issueStatuses).find(([, value]) => value === type)?.[0];
};

export const issueTypeFromId = (type: string) => {
  return Object.entries(issueTypes).find(([, value]) => value === type)?.[0];
};
